export const CONTACT_SALES = 'https://hotjar.chilipiper.com/router/billing-cta-router';

export const PRICING_MODEL_CHANGES_URL = 'https://www.hotjar.com/blog/updating-our-pricing-model/';
